import { v4 } from 'uuid';

import type { SavedCashNdf } from '@/domain/WorkspaceForex/savedProducts/cash/SavedCashNdf.ts';
import type { FxCashNdf } from '@/store/cash/state.ts';

export const mapToFxCashNdf = ({ properties, clientId }: SavedCashNdf): FxCashNdf => {
  const [currency1, currency2] = properties.currencyPair?.split('/') ?? [undefined, undefined];

  return {
    type: 'FxNdf',
    clientId,
    properties: {
      currencyPair: properties.currencyPair ?? undefined,
      currency1,
      currency2,
      maturityDate: undefined,
      maturityDateTenor: properties.maturityDateTenor, // TODO: can hive tenor like 6D in workspace, is this the right type ?
      notional: properties.notional,
      notionalCurrencyIndex: properties.notionalCurrencyIndex ?? 1, // default to 1 to fix issue during the migration
    },

    tradeCapture: {
      status: 'INITIALIZED',
      sessionId: v4(),
      version: -1,
    },
  };
};
